import 'aframe';

// custom rounded rectangle component
AFRAME.registerComponent('rounded-rect', {
  schema: {
    width: { type: 'number', default: 1 },
    height: { type: 'number', default: 1 },
    radius: { type: 'number', default: 0.1 },
    color: { type: 'string', default: '#ffffff' },
    opacity: { type: 'number', default: 1.0 }
  },

  createRoundedRect: function(width, height, radius, color, opacity) {
    // create a rounded rectangle using ShapeGeometry
    const shape = new AFRAME.THREE.Shape();
    const minDimension = Math.min(width, height);
    const proportionalRadius = (radius / 100) * minDimension;

    let actualRadius = Math.min(proportionalRadius, minDimension / 2);

    const minRadius = 0.1; // minimum radius
    actualRadius = Math.max(actualRadius, minRadius);

    // create rounded rectangle path
    const x = -width / 2;
    const y = -height / 2;

    shape.moveTo(x + actualRadius, y);
    shape.lineTo(x + width - actualRadius, y);
    shape.quadraticCurveTo(x + width, y, x + width, y + actualRadius);
    shape.lineTo(x + width, y + height - actualRadius);
    shape.quadraticCurveTo(x + width, y + height, x + width - actualRadius, y + height);
    shape.lineTo(x + actualRadius, y + height);
    shape.quadraticCurveTo(x, y + height, x, y + height - actualRadius);
    shape.lineTo(x, y + actualRadius);
    shape.quadraticCurveTo(x, y, x + actualRadius, y);

    const geometry = new AFRAME.THREE.ShapeGeometry(shape);
    const material = new AFRAME.THREE.MeshBasicMaterial({
      color,
      side: AFRAME.THREE.DoubleSide,
      transparent: true,
      opacity
    });

    return new AFRAME.THREE.Mesh(geometry, material);
  },

  init: function() {
    const data = this.data;
    this.mesh = this.createRoundedRect(data.width, data.height, data.radius, data.color, data.opacity);
    this.el.setObject3D('mesh', this.mesh);
  },

  update: function() {
    const data = this.data;
    this.mesh = this.createRoundedRect(data.width, data.height, data.radius, data.color, data.opacity);
    this.el.setObject3D('mesh', this.mesh);
  }
});
